import React from "react"
import { useForm } from "react-hook-form"
import { User } from "firebase/auth"
import { api, firestore } from "../../core"
import { usePublicSpaceBackgroundsForAdmin } from "popopo-lib-front/firestore-access"
import { useToast } from "popopo-lib-front/hook"

type SpaceCreateForms = {
  name: string
  backgroundId: string
}

export const SpaceCreateForm = (props: { firebase: User }) => {
  const backgrounds = usePublicSpaceBackgroundsForAdmin(firestore)
  const form = useForm<SpaceCreateForms>({
    mode: "onBlur",
    defaultValues: {
      name: "sample space",
      backgroundId: ""
    },
  })
  const toast = useToast()
  const { isSubmitting, isValid, errors } = form.formState

  const onSubmit = async (value: SpaceCreateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: { ...value },
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "スペース作成", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "スペース作成", message: e.message })
      throw e
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          {backgrounds === "loading" ? <p>背景を読込中</p> : <select className="form-select" {...form.register("backgroundId", { required: true })}>
            {backgrounds.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
          </select>}
          <label>背景</label>
        </div>
        <div className="form-floating">
          <input className="form-control" disabled={isSubmitting} {...form.register("name")} />
          <label>Name</label>
        </div>

        {errors.name?.message && <div className="text-danger"> {errors.name.message}</div>}

        <button type="submit" className="btn btn-primary form-control" disabled={!isValid || isSubmitting}>
          Call &quot;POST /spaces&quot; API
        </button>
      </form>
    </>
  )
}
